

//Module
import { Modal , Box , Typography , IconButton } from "@mui/material"
import { i_view_modal_props } from "../../interfaces/utility.interface"


//Icons
import CloseIcon from '@mui/icons-material/Close';
import { i_user_view_modal } from "../../interfaces/display.interfaces";

const UserViewModal = ( props : i_user_view_modal ) => {

    return (
        <Modal open={props.open} onClose={() => props.setOpen(false)}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', }} >
                <Box sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, p: 2, borderRadius: 2, maxWidth: '90%', maxHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', }} >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Typography variant="h6">{props.user.username}</Typography>
                        <IconButton onClick={() => props.setOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Typography variant="body1">Email : {props.user.email}</Typography>
                        <Typography variant="body1">Phone : {props.user.phone}</Typography>
                        <Typography variant="body1">Address : {props.user.creditLimit}</Typography>
                        <Typography variant="body1">All the rest...</Typography>

                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

export default UserViewModal